import React, { ReactNode } from "react";
import { TabContextProvider } from "./tab-context";

interface TabContainerProps {
  children: ReactNode;
  defaultActiveKey: string;
  activeTabKey: string; // Define the defaultActiveKey prop
  onTabChange?: (activeTab: string) => void;
}

const TabContainer: React.FC<TabContainerProps> = ({
  children,
  defaultActiveKey,
  activeTabKey,
  onTabChange,
}: TabContainerProps) => {
  return (
    <TabContextProvider defaultActiveKey={defaultActiveKey} onTabChange={onTabChange} activeTabKey={activeTabKey}>
      {children}
    </TabContextProvider>
  );
};

export { TabContainer };
